__turbopack_context__.v({
  "actions": "OwnerSurveyPicnic-module-sass-module__M9UJRa__actions",
  "background": "OwnerSurveyPicnic-module-sass-module__M9UJRa__background",
  "block": "OwnerSurveyPicnic-module-sass-module__M9UJRa__block",
  "button": "OwnerSurveyPicnic-module-sass-module__M9UJRa__button",
  "content": "OwnerSurveyPicnic-module-sass-module__M9UJRa__content",
  "description": "OwnerSurveyPicnic-module-sass-module__M9UJRa__description",
});
